var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "18px",
    viewBox: "0 0 21 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "school") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded",
    transform: "translate(-136.000000, -4145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social",
    transform: "translate(100.000000, 4044.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Round-/-Social-/-school",
    transform: "translate(34.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,13.18 L5,15.99 C5,16.72 5.4,17.4 6.04,17.75 L11.04,20.48 C11.64,20.81 12.36,20.81 12.96,20.48 L17.96,17.75 C18.6,17.4 19,16.72 19,15.99 L19,13.18 L12.96,16.48 C12.36,16.81 11.64,16.81 11.04,16.48 L5,13.18 Z M11.04,3.52 L2.61,8.12 C1.92,8.5 1.92,9.5 2.61,9.88 L11.04,14.48 C11.64,14.81 12.36,14.81 12.96,14.48 L21,10.09 L21,16 C21,16.55 21.45,17 22,17 C22.55,17 23,16.55 23,16 L23,9.59 C23,9.22 22.8,8.89 22.48,8.71 L12.96,3.52 C12.36,3.2 11.64,3.2 11.04,3.52 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#1D1D1D"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.213f36d40d21af6222ae08ac523a189b.svg";
export { ForwardRef as ReactComponent };